import Script from 'next/script'

import { GTM_CONSENT_BOOTSTRAP_TEST_IDS } from '@common/common-test-ids.const'
import { GTM_CONSENT_BOOTSTRAP_SCRIPT_ID } from '@common/gtm.const'
import { buildGtmConsentBootstrapScript } from '@common/utils/gtm-consent-bootstrap.utils'

/* eslint-disable @next/next/no-before-interactive-script-outside-document -- App Router root layout; consent must run before GTM */
export function GtmConsentBootstrap() {
  return (
    <span data-testid={GTM_CONSENT_BOOTSTRAP_TEST_IDS.root} hidden>
      <Script
        id={GTM_CONSENT_BOOTSTRAP_SCRIPT_ID}
        strategy="beforeInteractive"
        // eslint-disable-next-line react-dom/no-dangerously-set-innerhtml -- output of buildGtmConsentBootstrapScript() only
        dangerouslySetInnerHTML={{ __html: buildGtmConsentBootstrapScript() }}
      />
    </span>
  )
}
